<template>
  <div
    class="mapSection w-full h-screen bg-no-repeat bg-cover relative overflow-hidden flex justify-center items-center px-8"
    :class="bgClass"
  >
    <div class="w-full max-w-192 flex flex-row">
      <div class="slider-cont w-full">
        <div class="slider-wrapper relative">
          <VueSlickCarousel
            ref="mapSlider"
            v-bind="settings"
            @beforeChange="beforeChangeCarousel"
          >
            <div
              class="map-slide"
              v-for="(mapSlide, index) in mapData"
              :key="index"
            >
              <div
                class="map-slide flex flex-row 4xl:justify-start items-start lg:justify-center"
              >
                <div
                  class="map-title-wrapper flex flex-col pt-20 xl:w-3/12 lg:w-3/12"
                >
                  <div
                    class="map-type-wrapper relative overflow-hidden h-16 float-left opacity-0 xl:block lg:hidden"
                    :class="typeClass"
                  >
                    <span
                      class="map-type absolute inset-0 m-auto w-full text-very-light-gray 2xl:text-2 xl:text-1.6 uppercase 2xl:p-2 xl:p-4 text-center z-10"
                      v-html="mapSlide.type"
                    ></span>
                    <div
                      :class="typeClass2"
                      class="absolute h-16 inset-0 m-auto bg-vivid-pink"
                    ></div>
                  </div>
                  <div
                    class="lg:w-full lg:max-w-xs lg:block bg-vivid-pink text-very-light-gray lg:text-1.6 p-2 xl:hidden"
                  >
                    {{ mapSlide.type }}
                  </div>
                  <h1
                    class="map-title w-11/12 xl:h-177 lg:h-44 font-rakkas 2xl:text-8.4xl xl:text-8xl lg:text-4.4 2xl:leading-8.6 text-very-dark-gray mt-0.1 opacity-0 "
                    v-html="mapSlide.name"
                  ></h1>
                  <div
                    class="relative flex flex-row items-center justify-start mt-10"
                  >
                    <span
                      class="line absolute w-0.5 2xl:h-52 xl:h-40 lg:h-32 bg-very-dark-gray top-4 left-2.6"
                    ></span>
                    <ul>
                      <li
                        @click="goToSlide(index)"
                        class="flex flex-row items-center 2xl:mt-4 xl:mt-3 lg:mt-3 cursor-pointer"
                        v-for="(dot, index) in mapData"
                        :key="dot.type"
                      >
                        <span
                          :class="
                            activePage === index
                              ? 'text-vivid-pink'
                              : 'text-very-dark-gray'
                          "
                          class="number font-mulish-medium w-5 2xl:text-1.6 xl:text-1.4"
                          >{{ dot.id }}</span
                        >
                        <span
                          :class="
                            activePage === index
                              ? 'bg-vivid-pink'
                              : 'bg-very-dark-gray'
                          "
                          class="dot block z-20 rounded-full w-2 h-2 ml-5 mr-5"
                        ></span>
                        <span
                          :class="
                            activePage === index
                              ? 'text-vivid-pink'
                              : 'text-very-dark-gray'
                          "
                          class="name font-mulish-medium w-full uppercase 2xl:text-1.6 xl:text-1.4"
                          >{{ dot.name }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="4xl:w-9/12 xl:w-8/12 lg:w-8/12 flex flex-col">
                  <div class="image-wrapper 3xl:w-9/12 xl:w-8/12 lg:w-full">
                    <img
                      class="map-image 2xl:w-11/12 xl:w-full"
                      :src="`${imgPath}/Section04/${mapSlide.imgUrl}`"
                    />
                  </div>
                  <div
                    class="description-wrapper flex flex-row mt-70 2xl:mt-14 xl:mt-10 lg:mt-4"
                  >
                    <div
                      class="story-wrapper 3xl:w-6/12 2xl:w-5/12 lg:w-6/12 first:mr-14"
                      v-for="(desc, descIndex) in mapSlide.desc"
                      :key="descIndex"
                    >
                      <div
                        class="story-header flex flex-row 4xl:items-center lg:items-start"
                      >
                        <span
                          class="part xl:w-7.4 xl:h-2.8 lg:w-20 lg:h-8 bg-vivid-pink 2xl:text-1.6 xl:text-1.4 lg:text-1 text-white uppercase flex justify-center items-center mr-2 p-1"
                          >part {{ descIndex + 1 }}</span
                        >
                        <h3
                          class="text-2.2 font-mulish-bold text-very-dark-gray 2xl:text-2 xl:text-1.6 lg:text-1.2"
                          v-html="desc.title"
                        ></h3>
                      </div>
                      <p
                        class="font-mulish-medium 2xl:text-1.6 xl:text-1.4 lg:text-1.2 2xl:leading-normal xl:overflow-visible lg:leading-tight mt-0.1 xl:h-auto lg:h-195 lg:overflow-y-scroll"
                        v-html="desc.text"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
//import SectionTag from '../components/SectionTag.vue';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      activePage: 0,
      bgClass: 'bg-section-4-1',
      typeClass: 'w-139',
      typeClass2: 'w-11',
      settings: {
        dots: false,
        arrows: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        useCSS: false,
        speed: 5000,
        autoplaySpeed: 5000,
      },
    };
  },
  methods: {
    resetAnimation: function() {
      this.$store.commit('ANIMATION/RESET_MAP_SECTION');
    },
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_MAP_SECTION');
    },
    beforeChangeCarousel: function(oldIndex, newIndex) {
      //console.log(newIndex);
      this.activePage = newIndex;
      if (newIndex === 0) {
        this.bgClass = 'bg-section-4-1';
        this.typeClass = 'w-139';
        this.typeClass2 = 'w-11';
      }
      if (newIndex === 1) {
        this.bgClass = 'bg-section-4-2';
        this.typeClass = 'w-139';
        this.typeClass2 = 'w-11';
      }
      if (newIndex === 2) {
        this.bgClass = 'bg-section-4-3';
        this.typeClass = 'w-316';
        this.typeClass2 = 'w-138';
      }
      if (newIndex === 3) {
        this.bgClass = 'bg-section-4-4';
        this.typeClass = 'w-316';
        this.typeClass2 = 'w-138';
      }

      this.initAnimation();
      this.resetAnimation();
    },
    goToSlide: function(index) {
      this.$refs.mapSlider.goTo(index);
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      pageNumber: state => state.AppConfig.pageNumber,
      mapData: state => state.MapSection.mapData,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.mapSection {
  transition: background-image 0.2s ease-in-out;
}
.map-type-wrapper:before {
  content: '';
  position: absolute;
  top: -15px;
  left: 0px;
  border-top: 35px solid transparent;
  border-right: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
.map-type-wrapper:after {
  content: '';
  position: absolute;
  top: -15px;
  right: 0px;
  border-top: 35px solid transparent;
  border-left: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}

.slider-wrapper >>> .slick-dots {
  @apply w-96 flex flex-col top-3/10 xl:mt-16 lg:mt-20 4xl:left-0 3xl:left-0.4/10 !important;
}
.slider-wrapper >>> .slick-dots li {
  @apply w-full mt-4 text-left;
}
.slider-wrapper >>> .slick-dots .slick-active .dots-wrapper .number {
  @apply text-vivid-pink;
}
.slider-wrapper >>> .slick-dots .slick-active .dots-wrapper .dot {
  @apply bg-vivid-pink;
}
.slider-wrapper >>> .slick-dots .slick-active .dots-wrapper .name {
  @apply text-vivid-pink;
}
.slider-wrapper >>> .part-btn-cont .part-btn-active {
  @apply border-white;
}
</style>
